import "./footer.css";

import React from "react";

import { LINKS } from "../../data/content";
import Picture from "../general/Picture";
import PlatformLinks from "../general/PlatformLinks";

const Footer = () => {
  return (
    <footer className={"site-footer"}>
      <Picture
        name={"footer"}
        widths={[1600]}
        sizes={"100vw"}
        alt={""}
        width={"1600"}
        height={"892"}
        className={"footer-bg"}
      />
      <p className={"footer-copyright"}>
        &copy; {new Date().getFullYear()} Artdacity. Proudly created by{" "}
        <a
          href={LINKS.TAPX}
          target={"_blank"}
          rel={"noopener noreferrer"}
        >
          TapX
        </a>
      </p>
      <PlatformLinks
        className={"footer-platforms"}
        onDark={true}
      />
    </footer>
  );
};

export default Footer;
